module.exports = __webpack_public_path__ + "img/vg.6b8e0ffa.svg";